import type { LogLevel} from "whole-shared";
import { setLogger } from "whole-shared";

import { hud } from "./match/hud";

const begin = Date.now();

const logs: [number, LogLevel, unknown[]][] = [];
const prevLogs: [LogLevel, unknown[]][] = [];

let logAttached = false;

hud.on("logAttached", attached => (logAttached = attached));

const log = (level: LogLevel, ...args: unknown[]) => {
  logs.push([performance.now(), level, args]);
};

setLogger({
  debug: log.bind(null, "debug"),
  error: log.bind(null, "error"),
  info:  log.bind(null, "info"),
  warn:  log.bind(null, "warn")
});

const pad = (n: number) => n.toString().padStart(2, "0");

setInterval(() => {
  if(logAttached) {
    for(const [level, args] of prevLogs) hud.emit("log", level, ...args);

    prevLogs.length = 0;
  }

  for(const [time, level, args] of logs) {
    const t = begin + time;
    const d = new Date(t);
    const withUs = t / 1000;
    const msgs = [`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}${(withUs - Math.floor(withUs)).toFixed(5).slice(1)}`, ...args];

    // eslint-disable-next-line no-console
    console[level](...msgs);

    if(logAttached) hud.emit("log", level, ...msgs);
    else prevLogs.push([level, args]);
  }

  if(logs.length) logs.length = 0;
}, 100);
